import React from "react";
import mainImg from "../images/main-img.svg";
import Button from "./Button";
import { navigate } from "gatsby";

function Hero() {

  return (
    <main className="flex flex-col lg:flex-row items-center lg:justify-around mx-auto mt-10 px-6 lg:px-20 lg:pb-16 max-w-6xl relative">
      <div className="text-center lg:text-left w-4/5 sm:w-2/3 lg:w-1/2 mx-auto py-4" data-aos="fade-in">
        <h2 className="text-3xl leading-tight font-extrabold text-gray-900 xs:text-4xl sm:text-5xl">
          Get a done-for-you landing page <br /><span className="text-indigo-600">in less than 7 days</span>
        </h2>
        <p className="mt-6 text-base max-w-md font-body text-gray-700 sm:text-lg md:text-xl">
          We will build a conversion optimized, personally tailored and blazing fast landing page for your product within a week.
        </p>
        <div className="mt-5 sm:mt-8 sm:flex justify-center lg:justify-start">
          <Button
            btnText="Get started"
            color="dark"
            onClick={() => navigate('/start')}
          />
        </div>
      </div>
      <div className="mx-auto mt-6 mb-16 lg:m-0 w-full lg:w-1/2" data-aos="fade-up">
        <img height="500" width="1000" className="w-5/6 mx-auto h-full z-20 object-contain" src={mainImg} alt="main-img" />
      </div>
      <div className="absolute benefit-description-background h-96 w-2/5 left-0 transform -translate-x-1/2 translate-y-1/2"></div>
    </main>
  );
}

export default Hero;